import styled from 'styled-components';

import { Bold } from '@components/Styled';
import { flexAsColumn, flexAsRow } from '@components/Styled/mixins';

const SummaryCardWrapper = styled.div`
  ${flexAsColumn(1)};

  width: 100%;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing(2)} !important;
  border-radius: ${({ theme }) => theme.spacing(2)};
  background-color: ${({ theme, secondary }) => (secondary
    ? theme.colors.secondary.lighterBlue
    : theme.colors.neutral.chromatic[100])};

  h4 {
    margin: 0;
    white-space: nowrap;
  }

  p {
    white-space: nowrap;
  }
`;

const TitleCard = styled.div`
  ${flexAsRow(0.5)};
`;

const CircleWrapper = styled.div`
  display: flex;
  min-width: ${({ theme }) => theme.spacing(2)};
  padding: 0 ${({ theme }) => theme.toRem(7)};
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  background-color: ${({ theme }) => theme.colors.brand.main[900]};
  color: ${({ theme }) => theme.colors.neutral.chromatic[100]};
  font-size: ${({ theme }) => theme.toRem(10)};
`;

const TitleContainer = styled.div`
  ${flexAsRow(1)};

  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

const TotalContainer = styled.div`
  ${flexAsRow()};

  width: 100%;
  padding-top: ${({ theme }) => theme.spacing(1)};
  justify-content: space-between;
  border-top: 1px solid ${({ theme }) => theme.colors.neutral.gray[500]};

  > p:last-of-type {
    text-align: end;
  }
`;

const TotalTitle = styled(Bold)`
  font-size: ${({ theme }) => theme.toRem(16)} !important;
`;

const DataContainer = styled.div`
  ${flexAsColumn(1)};

  strong {
    font-size: ${({ theme }) => theme.toRem(14)};
  }
`;

const AuxiliaryDataContainer = styled.div`
  ${flexAsRow(1)};

  width: 100%;
  align-items: center;
  justify-content: space-between;

  > div:nth-of-type(1) {
    > p {
      overflow-wrap: break-word;
      word-break: break-word;
      white-space: pre-line;
    }
  }
`;

export {
  AuxiliaryDataContainer,
  CircleWrapper,
  DataContainer,
  SummaryCardWrapper,
  TitleCard,
  TitleContainer,
  TotalContainer,
  TotalTitle
};
